var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',[_c('CCard',[_c('CCardHeader',[_c('strong',[_vm._v("Создать консьержа")])]),_c('CCardBody',[_c('ConciergeUpsertForm',{on:{"success":function($event){return _vm.$router.push("/concierges")}}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }